export default "__VITE_ASSET__DQghTE5H__"